import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import { useAuthorizedAxiosClient } from "../../../../common/axios"

export default function ConfirmDeleteSMSCampaignDialog({
  open,
  onClose,
  smsCampaign,
}) {
  const [isDeleting, setIsDeleting] = useState(false)
  const axios = useAuthorizedAxiosClient()

  function handleSoftClose() {
    onClose()
  }

  function handleDeleteButtonClicked() {
    setIsDeleting(true)
    axios
      .delete(`/workflows/api/sms/${smsCampaign.id}/`)
      .then(() => onClose(true))
      .finally(() => setIsDeleting(false))
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete campaign:{" "}
          <strong>{smsCampaign?.name}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isDeleting}
          onClick={handleDeleteButtonClicked}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
